import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, MapPin, Linkedin, Star } from 'lucide-react';
const accreditations = [{
  name: 'Daikin D1+ Premium Partner',
  src: 'https://cdn.magicpatterns.com/uploads/2vVokvhsbE3igxg2bfPash/d1.png'
}, {
  name: 'Mitsubishi Electric Accredited Installer',
  src: 'https://cdn.magicpatterns.com/uploads/u4wNLmkihgfoVY6zFXiVRD/acc-mitsubishi.png'
}, {
  name: 'Fujitsu Infinity Partner',
  src: 'https://cdn.magicpatterns.com/uploads/2bur7AKX4bav4Ji73hJpM7/acc-fujitsu.png'
}, {
  name: 'Constructionline Gold',
  src: 'https://cdn.magicpatterns.com/uploads/2FA87CtJq3CRcUi4Xcmf5w/acc-chas.png'
}, {
  name: 'Safe Contractor',
  src: 'https://cdn.magicpatterns.com/uploads/jFm1QpjEmC16VTGoXegaaN/acc-safe.png'
}, {
  name: 'BESA',
  src: 'https://cdn.magicpatterns.com/uploads/jo6rVf4k1TsuFxc8CF9hSk/acc-besa.png'
}, {
  name: 'ISO 9001',
  src: 'https://cdn.magicpatterns.com/uploads/eXZzz3xSbHUJ1wTfq3KUK3/acc-iso.png'
}];
export function FooterV2() {
  return <footer className="w-full bg-primary-dark text-white overflow-hidden relative" data-id="element-154">
      <div className="absolute top-0 right-0 w-2/3 h-full bg-white/[0.02] -skew-x-12 translate-x-32 pointer-events-none" data-id="element-155"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-156">
        <div className="py-32 md:py-40 border-b border-white/10 flex flex-col md:flex-row items-start md:items-end justify-between gap-10" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-158">
            <h2 className="text-6xl md:text-8xl font-serif leading-[1.05] tracking-tight mb-8 text-white" data-id="element-159">
              Ready to <span className="text-accent italic" data-id="element-160">talk?</span>
            </h2>
            <p className="text-xl md:text-2xl text-white/60" data-id="element-161">
              Let's discuss your commercial HVAC requirements and find the
              perfect solution for your business.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-162">
            <Link to="/contact" className="group flex items-center justify-center w-40 h-40 md:w-52 md:h-52 bg-accent hover:bg-white text-white hover:text-primary-dark rounded-full transition-colors duration-500" data-id="element-163">
              <ArrowRight className="w-12 h-12 md:w-16 md:h-16 -rotate-45 group-hover:rotate-0 transition-transform duration-500" data-id="element-164" />
            </Link>
          </motion.div>
        </div>
        <div className="py-28 md:py-32 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-12" data-id="element-165">
          <div className="lg:col-span-4 pr-8" data-id="element-166">
            <Link to="/" className="block mb-10" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/m22cd52VGFAbga9BNLUyHJ/accutemp-logo-white.svg" alt="AccuTemp Air Conditioning" className="h-14 w-auto" data-id="element-168" />
            </Link>
            <p className="text-base text-white/70 leading-relaxed mb-10 max-w-sm" data-id="element-169">
              AccuTemp is the UK's trusted commercial air conditioning
              specialist. Headquartered in Coventry with nationwide coverage, we
              deliver installation, maintenance, and compliance services built
              to last.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-primary-dark hover:bg-accent hover:text-white px-8 py-4 rounded-full font-bold text-sm transition-colors" data-id="element-170">
              Contact us <ArrowRight className="w-4 h-4" data-id="element-171" />
            </Link>
          </div>
          <div className="lg:col-span-2" data-id="element-172">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-8" data-id="element-173">
              Services
            </h4>
            <ul className="space-y-4 text-sm text-white/80" data-id="element-174">
              <li data-id="element-175">
                <Link to="/services/installation" className="hover:text-accent transition-colors" data-id="element-176">
                  Installation
                </Link>
              </li>
              <li data-id="element-177">
                <Link to="/services/maintenance" className="hover:text-accent transition-colors" data-id="element-178">
                  Maintenance
                </Link>
              </li>
              <li data-id="element-179">
                <Link to="/services/tm44" className="hover:text-accent transition-colors" data-id="element-180">
                  TM44 compliance
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/services/ventilation" className="hover:text-accent transition-colors" data-id="element-182">
                  Ventilation
                </Link>
              </li>
              <li data-id="element-183">
                <Link to="/services" className="hover:text-accent transition-colors" data-id="element-184">
                  All services
                </Link>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-2" data-id="element-185">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-8" data-id="element-186">
              Company
            </h4>
            <ul className="space-y-4 text-sm text-white/80" data-id="element-187">
              <li data-id="element-188">
                <Link to="/about" className="hover:text-accent transition-colors" data-id="element-189">
                  About AccuTemp
                </Link>
              </li>
              <li data-id="element-190">
                <Link to="/why-accutemp" className="hover:text-accent transition-colors" data-id="element-191">
                  Why choose us
                </Link>
              </li>
              <li data-id="element-192">
                <Link to="/case-studies" className="hover:text-accent transition-colors" data-id="element-193">
                  Case studies
                </Link>
              </li>
              <li data-id="element-194">
                <Link to="/knowledge-hub" className="hover:text-accent transition-colors" data-id="element-195">
                  Resources
                </Link>
              </li>
              <li data-id="element-196">
                <Link to="/contact" className="hover:text-accent transition-colors" data-id="element-197">
                  Contact
                </Link>
              </li>
              <li data-id="element-198">
                <Link to="/areas-we-cover" className="hover:text-accent transition-colors" data-id="element-199">
                  Areas we cover
                </Link>
              </li>
              <li data-id="element-200">
                <Link to="/sitemap" className="hover:text-accent transition-colors" data-id="element-201">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-4" data-id="element-202">
            <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-8" data-id="element-203">
              Contact
            </h4>
            <div className="space-y-6" data-id="element-204">
              <a href="https://maps.google.com/?q=Justa+House+204-206+Holbrook+Lane+Coventry+CV6+4DD" target="_blank" rel="noopener noreferrer" className="flex items-start gap-4 text-sm text-white/80 hover:text-accent transition-colors group" data-id="element-205">
                <MapPin className="w-5 h-5 shrink-0 text-white/40 group-hover:text-accent transition-colors mt-0.5" data-id="element-206" />
                <span data-id="element-207">
                  Justa House, 204-206 Holbrook Lane,
                  <br data-id="element-208" />
                  Coventry, West Midlands, CV6 4DD
                </span>
              </a>
              <a href="https://linkedin.com/company/accutemp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-sm text-white/80 hover:text-accent transition-colors group" data-id="element-209">
                <Linkedin className="w-5 h-5 shrink-0 text-white/40 group-hover:text-accent transition-colors" data-id="element-210" />
                <span data-id="element-211">Follow us on LinkedIn</span>
              </a>
              <a href="https://www.google.com/search?q=accutemp+air+conditioning+reviews" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-sm text-white/80 hover:text-accent transition-colors group" data-id="element-212">
                <Star className="w-5 h-5 shrink-0 text-white/40 group-hover:text-accent transition-colors" data-id="element-213" />
                <span data-id="element-214">See our Google reviews</span>
              </a>
            </div>
          </div>
        </div>
        <div className="py-10 border-t border-white/10" data-id="element-215">
          <div className="flex flex-wrap justify-center md:justify-between items-center gap-x-12 gap-y-8" data-id="element-216">
            {accreditations.map((acc, i) => <div key={i} className="flex flex-col items-center gap-2 group max-w-[100px]" data-id="element-217">
                <img src={acc.src} alt={acc.name} className="h-7 md:h-8 w-auto object-contain brightness-0 invert opacity-40 group-hover:opacity-100 transition-opacity duration-300" data-id="element-218" />
                <span className="text-[8px] uppercase tracking-tighter text-white/20 group-hover:text-white/40 font-bold text-center transition-colors duration-300 leading-tight" data-id="element-219">
                  {acc.name}
                </span>
              </div>)}
          </div>
        </div>
        <div className="py-8 border-t border-white/10 text-center" data-id="element-220">
          <p className="text-xs text-white/40 leading-relaxed max-w-4xl mx-auto" data-id="element-221">
            Serving commercial sites across{' '}
            <Link to="/service-areas/birmingham" className="hover:text-white transition-colors" data-id="element-222">
              Birmingham
            </Link>
            ,{' '}
            <Link to="/service-areas/coventry" className="hover:text-white transition-colors" data-id="element-223">
              Coventry
            </Link>
            ,{' '}
            <Link to="/service-areas/solihull" className="hover:text-white transition-colors" data-id="element-224">
              Solihull
            </Link>
            ,{' '}
            <Link to="/service-areas/wolverhampton" className="hover:text-white transition-colors" data-id="element-225">
              Wolverhampton
            </Link>
            ,{' '}
            <Link to="/service-areas/warwick" className="hover:text-white transition-colors" data-id="element-226">
              Warwick
            </Link>
            ,{' '}
            <Link to="/service-areas/royal-leamington-spa" className="hover:text-white transition-colors" data-id="element-227">
              Leamington Spa
            </Link>
            ,{' '}
            <Link to="/service-areas/stoke-on-trent" className="hover:text-white transition-colors" data-id="element-228">
              Stoke-on-Trent
            </Link>
            ,{' '}
            <Link to="/service-areas/stafford" className="hover:text-white transition-colors" data-id="element-229">
              Stafford
            </Link>{' '}
            and surrounding towns including Aldridge, Cannock, Nuneaton, Rugby,
            Tamworth, Walsall and many more.{' '}
            <Link to="/areas-we-cover" className="text-accent hover:text-white transition-colors ml-1" data-id="element-230">
              View all areas we cover.
            </Link>
          </p>
        </div>
        <div className="py-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-white/40" data-id="element-231">
          <div className="text-center md:text-left space-y-1" data-id="element-232">
            <div data-id="element-233">Copyright © AccuTemp Air Conditioning Ltd 2026</div>
            <div data-id="element-234">Company Reg No: 08651949 | VAT Reg No: 171 8012 29</div>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-6" data-id="element-235">
            <a href="/cookies" className="hover:text-white transition-colors" data-id="element-236">
              Cookies
            </a>
            <a href="/privacy" className="hover:text-white transition-colors" data-id="element-237">
              Privacy policy
            </a>
            <a href="/gdpr" className="hover:text-white transition-colors" data-id="element-238">
              GDPR
            </a>
            <Link to="/sitemap" className="hover:text-white transition-colors" data-id="element-239">
              Sitemap
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}